import React, { useEffect, useRef, useState } from "react";
import { PreloaderPercent, PreloaderTracks } from "./Preloader";
import { useIndexedDB } from "../hooks/useIndexedDb";
import { Database } from "../utils";
import { MIN_VIDEO_SIZE_HACK } from "./utils";

const API_URL = process.env.REACT_APP_API_URL;

export function PlayerVideo({ context = {}, children }) {
  const videoRef = useRef(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [videoBlobUrl, setVideoBlobUrl] = useState(null);

  const { putValue, getValue, getAllValue, updateValue, deleteValue, isDBConnecting } =
    useIndexedDB(Database.name, [Database.videoTable]);

  /*useEffect(() => {
    if (context.state.translationDataAll) {
      const startTime = getFolderStartTime(context.state.translationDataAll, context.state.folder);
      if (startTime != null && videoRef.current) {
        console.log("startTime: ", startTime);
        context.handles.setPlayOriginalStart( startTime / 1000)
      }
    }
  }, [context.state.translationDataAll, context.state.folder]);*/

  const videoUrl = context.state.videoUrl
    ? `${API_URL}/output/${context.state.mediaId}/${context.state.videoUrl}`
    : "";
  useEffect(() => {
    const abortController = new AbortController();

    console.log(
      "context.state.video = ",
      Boolean(context.state.video),
      context.state.video,
      isDBConnecting,
    );

    async function fetchVideo(url, signal) {
      const response = await fetch(url, { signal });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status} ${response.statusText}`);
      }

      const contentLength = response.headers.get("Content-Length");
      const totalBytes = contentLength ? parseInt(contentLength, 10) : null;

      if (!response.body) {
        return await response.blob();
      }

      const reader = response.body.getReader();
      const chunks = [];
      let receivedBytes = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        receivedBytes += value.length;
        if (totalBytes && totalBytes > 0) {
          setLoadingProgress((receivedBytes / totalBytes) * 100);
        }
      }

      return new Blob(chunks);
    }

    async function getVideoFromDB() {
      try {
        const response = await getValue(Database.videoTable, context.state.mediaId);
        console.log("response: ", response);
        if (response && response.content && response.content.size > MIN_VIDEO_SIZE_HACK) {
          setVideoBlobUrl(URL.createObjectURL(response.content));
          setLoadingProgress(100);
        } else {
          let blob;

          try {
            blob = await fetchVideo(videoUrl, abortController.signal);
          } catch (err) {
            if (err.name === "AbortError") return;
            console.error("Video download failed, retrying in 2s:", err.message || err);
            await new Promise((r) => setTimeout(r, 2000));
            if (abortController.signal.aborted) return;
            blob = await fetchVideo(videoUrl, abortController.signal);
          }

          if (!blob || blob.size < MIN_VIDEO_SIZE_HACK) {
            console.error("File downloaded is too small, size:", blob?.size);
            return;
          }

          const blobUrl = URL.createObjectURL(blob);
          putValue(Database.videoTable, {
            mediaId: context.state.mediaId,
            name: context.state.videoUrl,
            content: blob,
            id: context.state.mediaId,
          });
          setVideoBlobUrl(blobUrl);
          setLoadingProgress(100);
        }
      } catch (e) {
        if (e.name === "AbortError") return;
        console.error("Video download error:", e.message || e, e);
      }
    }

    if (!isDBConnecting && context.state.video) {
      getVideoFromDB();
    }

    return () => {
      abortController.abort();
    };
  }, [context.state.video, isDBConnecting]);

  // Play or pause the video based on the 'playing' prop
  useEffect(() => {
    if (videoRef.current) {
      if (context.state.playing) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [context.state.playing]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = context.state.playbackRate;
    }
  }, [context.state.playbackRate]);

  // Set the start time of the video based on the 'startTime' prop
  useEffect(() => {
    let startTime = context.state.playOriginalStart;
    if (startTime != null && videoRef.current) {
      videoRef.current.currentTime = startTime / 1000;
    }
  }, [context.state.playOriginalStart]);

  return (
    <div className="c" style={{ width: "100%" }}>
      <div className="x_player_video0">
        {children}

        {Boolean(context.state.videoUrl) &&
          Boolean(context.state["mp3"]) &&
          Boolean(context.state.video) &&
          Boolean(loadingProgress === 100) && (
            <div className="x_player_video_sett0">
              <div
                className={`x_player_video_set_1 ${context.state.video === "sm" ? "active" : ""}`}
                onClick={() => context.handles.setVideo("sm")}
              >
                <div className="ico">
                  <div>crop_7_5</div>
                </div>
              </div>

              <div
                className={`x_player_video_set_1 ${context.state.video === "md" ? "active" : ""}`}
                onClick={() => context.handles.setVideo("md")}
              >
                <div className="ico">
                  <div>crop_5_4</div>
                </div>
              </div>

              <div
                className={`x_player_video_set_1 ${context.state.video === "full" ? "active" : ""}`}
                onClick={() => context.handles.setVideo("full")}
              >
                <div className="ico">
                  <div>fullscreen</div>
                </div>
              </div>
            </div>
          )}

        {Boolean(videoUrl) && loadingProgress < 100 && (
          <PreloaderTracks>
            {/* <PreloaderGif width={44} height={44} /> */}
            {Boolean(context.state.video) && (
              <PreloaderPercent>Видео загружается: {Math.round(loadingProgress)}%</PreloaderPercent>
            )}
          </PreloaderTracks>
        )}

        {Boolean(context.state.video) && Boolean(videoUrl) && loadingProgress === 100 && (
          <video
            preload="auto"
            style={{ zIndex: 0, visibility: Boolean(context.state.video) ? "visible" : "hidden" }}
            ref={videoRef}
            className={`x_player_video x_player_video--${context.state.video}`}
            muted
          >
            <source src={videoBlobUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}

        {!Boolean(loadingProgress === 100) && <div className={`x_player_video`}></div>}
      </div>
    </div>
  );
}
